//List of all locations


    var locations = [
      

        {
            "name": "Jeffers Pet Supply",
            "phone": "800-533-3377",
            "url": "https://www.jefferspet.com/metro?_q=METRO&map=ft",
            "categories": ["pets"],
            "country": "US",
            "state": "Alabama"
        },
        {
            "name": "Motion Industries, Inc.",
            "phone": "205-956-1122",
            "url": "https://www.motionindustries.com/",
            "categories": ["auto", "motorcycle", "industrial"],
            "country": "US",
            "state": "Alabama"
        },
        {
            "name": "PetSmart",
            "phone": "888-839-9638",
            "url": "https://www.petsmart.com/search/?q=metrovac&ps=undefined",
            "categories": ["pets"],
            "country": "US",
            "state": "Arizona"
        },
        {
            "name": "Ryan's Pet Supplies",
            "phone": "800-525-7387",
            "url": "https://store.ryanspet.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "Arizona"
        },
        {
            "name": "Magnell Associate, Inc.",
            "phone": "626-271-9700",
            "url": "https://www.newegg.com/Product/ProductList.aspx?Submit=ENE&N=8000%2050025894&IsNodeId=1&Description=metro&Order=BESTMATCH",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Petco Animal Supplies, Inc.",
            "phone": "877-738-6742",
            "url": "https://www.petco.com/shop/SearchDisplay?categoryId=&storeId=10151&catalogId=10051&langId=-1&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&searchSource=Q&pageView=&beginIndex=0&pageSize=48&fromPageValue=search&searchKeyword=&searchTerm=metrovac",
            "categories": ["pets"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "WAGS - Westcoast Animal Groomers Supply",
            "phone": "800-794-3123",
            "url": "https://www.wagsupply.com/SearchResults.asp?searching=Y&sort=1&search=Metro&show=90&page=1",
            "categories": ["pets"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Mightypets.com",
            "phone": "800-865-6734",
            "url": "http://www.mightypets.com/search.aspx?keyword=metro",
            "categories": ["pets"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Pet Food Express",
            "phone": "510-924-3300",
            "url": "https://www.petfoodexpress.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "3D of Oxnard Detailing Supplies",
            "phone": "805-485-9700",
            "url": "https://www.3dproducts.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Newegg Inc.",
            "phone": "800-390-1119",
            "url": "https://www.newegg.com/Product/ProductList.aspx?Submit=ENE&DEPA=0&Order=BESTMATCH&Description=METRO&N=-1&isNodeId=1",
            "categories": ["auto", "home", "motorcycle", "electronics", "industrial"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "West Coast Corvette",
            "phone": "888-737-8388",
            "url": "http://www.westcoastcorvette.com/search.aspx?searchterm=METRO",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Detailing.com",
            "phone": "800-380-5773",
            "url": "https://www.detailing.com/store/brands/index/view/id/35",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "BikeBandit.com",
            "phone": "888-339-3888",
            "url": "https://www.bikebandit.com/air-force-blaster/00dh44x",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "California Car Cover",
            "phone": "800-423-5525",
            "url": "https://www.calcarcover.com/search/METRO%20VAC",
            "categories": ["auto", "home", "motorcycle", "camping"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Neobits Inc.",
            "phone": "866-636-2487",
            "url": "https://www.neobits.com/metrovac_datavac_m21794.html",
            "categories": ["auto", "home", "motorcycle", "electronics", "industrial"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Auto Anything Inc",
            "phone": "800-874-8888",
            "url": "https://www.autoanything.com/shop/metro?N=4294966234",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "SoCal Wax Shop",
            "phone": "951-698-1777",
            "url": "https://socalwaxshop.com/brands/Metro-Vac.html",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Classic Industries",
            "phone": "800-854-1280",
            "url": "https://www.classicindustries.com/shop/search/?q=VAC%20N%20BLO",
            "categories": ["auto", "motorcycle", "camping"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Chemical Guys",
            "phone": "866-822-3670",
            "url": "https://www.chemicalguys.com/search?q=METRO&lang=default",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Smart Car Care Products",
            "phone": "619-575-9274",
            "url": "https://smartcarcareproducts.com/retail-and-wholesale/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Auto Detail Supplies Outlet",
            "phone": "none",
            "url": "https://autodetailsuppliesoutletbaldwinpark.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "3D Products of the Valley",
            "phone": "818-947-0355",
            "url": "https://www.carcareshopping.com/product-category/auto-detailing-machines/air-blowers/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Next Warehouse",
            "phone": "877-235-6628",
            "url": "http://www.nextwarehouse.com/search.cfm",
            "categories": ["auto", "motorcycle", "electronics"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "The Office City",
            "phone": "877-484-3633",
            "url": "http://www.nosi.biz/search.aspx?keyword=METRO%2Bvac",
            "categories": ["electronics"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Cyberguys, Inc.",
            "phone": "800-892-1010",
            "url": "https://www.cyberguys.com/product-search/?keyword=datavac",
            "categories": ["electronics"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "SYNNEX Corporation",
            "phone": "800-756-9888",
            "url": "https://www.synnexcorp.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "AB Airbags, Inc.",
            "phone": "760-268-1000",
            "url": "https://abairbags.com/search?q=pro+flo",
            "categories": ["camping"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "Neoprene Distributors International",
            "phone": "530-268-7300",
            "url": "https://watertrampolines.com/shop/inflators/metro-vac-magic-air-deluxe-inflator/",
            "categories": ["camping"],
            "country": "US",
            "state": "California"
        },
        {
            "name": "The Dog Supply Co",
            "phone": "860-689-2602",
            "url": "http://www.thedogsupplyco.com/store/list_products/?already_submitted=1&search_desc=METRO&x=0&y=0",
            "categories": ["pets"],
            "country": "US",
            "state": "Connecticut"
        },
        {
            "name": "Simoniz USA, Inc.",
            "phone": "800-227-5536",
            "url": "https://www.simoniz.com/",
            "categories": ["auto"],
            "country": "US",
            "state": "Connecticut"
        },
        {
            "name": "Adam's Premium Car Care Products",
            "phone": "866-965-0400",
            "url": "https://adamspolishes.com/pages/search-results-page?q=metrovac",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Colorado"
        },
        {
            "name": "Barn World",
            "phone": "720-238-2190",
            "url": "http://www.barnworld.com/?s=metro",
            "categories": ["pets"],
            "country": "US",
            "state": "Colorado"
        },
        {
            "name": "Airsled Inc",
            "phone": "302-292-8911",
            "url": "https://airsled.com/shop-airsled/",
            "categories": ["camping"],
            "country": "US",
            "state": "Delaware"
        },
        {
            "name": "Pinnacle Wax",
            "phone": "877-929-3100",
            "url": "https://www.pinnaclewax.com/car-vacuum-blower.html",
            "categories": ["pets", "auto", "home", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Autopia Car Care",
            "phone": "877-855-3125",
            "url": "https://www.autopia-carcare.com/metro-vaccums.html",
            "categories": ["pets", "auto", "home", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Pet Pro Supply Co.",
            "phone": "855-PET-PRO1",
            "url": "https://www.petprosupplyco.com/collections/metrovac",
            "categories": ["pets"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Rumbo Pet Supplies",
            "phone": "800-432-3647",
            "url": "http://www.rumbopet.com/metro.html",
            "categories": ["pets"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "AutoGeek.net",
            "phone": "800-869-3011",
            "url": "http://autogeek.commerce-search.net/",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Wolfgang Car Care",
            "phone": "800-547-8109",
            "url": "https://www.wolfgangcarcare.com/car-vacuum-blower.html",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Eckler's Corvette",
            "phone": "800-284-3906",
            "url": "https://www.ecklerscorvette.com/catalogsearch/result/?q=blaster&x=0&y=0",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "ES Distributions, LLC",
            "phone": "305-962-2099",
            "url": "https://www.esdistributions.com/",
            "categories": ["auto", "motorcycle", "electronics"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "BioTech Industries",
            "phone": "800-965-2927",
            "url": "https://www.bio-techusa.com/SearchResults.asp?Search=dryer&Submit=",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Sky's the Limit Car Care",
            "phone": "386-259-0759",
            "url": "https://www.carpro-us.com/metropolitan-vacuum-blowers/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Gamma Trade",
            "phone": "800-948-2178",
            "url": "http://www.gammatradeusa.com/car-vacuums-s/1838.htm",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "McKee's 37 Car Care",
            "phone": "844-852-5300",
            "url": "http://www.mckees37.com",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Prostock Marine",
            "phone": "954-457-5000",
            "url": "http://www.prostockmarine.com/index.php?id_category=15&controller=category",
            "categories": ["camping"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Allied Services Int'l Inc",
            "phone": "786-347-6015",
            "url": "none",
            "categories": ["industrial"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Pet-Agree Grooming Supplies",
            "phone": "800-734-4228",
            "url": "https://www.petagree.net/store/m/77-Metro-Vac.aspx?ps=60",
            "categories": ["pets"],
            "country": "US",
            "state": "Georgia"
        },
        {
            "name": "Hagemeyer",
            "phone": "678-746-2400",
            "url": "https://www.hagemeyerna.com/",
            "categories": ["pets", "auto", "electronics", "industrial"],
            "country": "US",
            "state": "Georgia"
        },
        {
            "name": "Team One Repair, Inc",
            "phone": "678-985-0772",
            "url": "https://www.poscleaning.com/cleaning-devices/",
            "categories": ["home", "electronics"],
            "country": "US",
            "state": "Georgia"
        },
        {
            "name": "S.P. Richards Company",
            "phone": "888-436-6881",
            "url": "http://www.sprichards.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Georgia"
        },
        {
            "name": "Chaparral Boats Inc",
            "phone": "none",
            "url": "http://www.chaparralboats.com/Chaparral-Boats.php",
            "categories": ["camping"],
            "country": "US",
            "state": "Georgia"
        },
        {
            "name": "Revival Animal Health, Inc.",
            "phone": "800-786-4751",
            "url": "http://pet-healthcare.revivalanimal.com/search?p=Q&lbc=revivalanimal&uid=932457270&ts=custom&w=metro&isort=score&method=and&view=grid&=&af=brand%3Ametropolitanvacuumcleanerco",
            "categories": ["pets"],
            "country": "US",
            "state": "Iowa"
        },
        {
            "name": "The Edge Pro",
            "phone": "515-963-1990",
            "url": "https://www.theedgepro.com/products/dryers-blowers-201/metro-dryers-243",
            "categories": ["pets"],
            "country": "US",
            "state": "Iowa"
        },
        {
            "name": "J & P Cycles",
            "phone": "800-318-4823",
            "url": "http://www.jpcycles.com/motorcycle-parts/vac-n-blo?Ntt=vacuum&Ntk=All",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Iowa"
        },
        {
            "name": "Midwest Grooming Supplies & Service",
            "phone": "800-558-0593",
            "url": "https://www.midwestgrooming.com/home.php?cat=299&xid=0001a479a1f3f8f6be9919fcfdb6c4db",
            "categories": ["pets"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "CCSI International, Inc",
            "phone": "844-404-3109",
            "url": "http://www.ccsiusa.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Chewy",
            "phone": "800-672-4399",
            "url": "https://www.chewy.com/s?rh=brand_facet%3AMetroVac",
            "categories": ["pets"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Ultrasonic Power Corporation",
            "phone": "800-575-0168",
            "url": "https://www.upcorp.com/index.html",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Auto Accessories Garage",
            "phone": "800-663-1570",
            "url": "https://www.autoaccessoriesgarage.com/brand/Metro-Vac",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Car Guy Garage",
            "phone": "800-736-9308",
            "url": "https://www.carguygarage.com/gaspclup.html",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Grainger Industrial Supply",
            "phone": "800-472-4643",
            "url": "https://www.grainger.com/search?searchQuery=metrovac&o...=",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Newark Element 14",
            "phone": "800-463-9275",
            "url": "https://www.newark.com/browse-for-products",
            "categories": ["home", "electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "CDW",
            "phone": "800-440-4239",
            "url": "https://www.cdw.com/search/?b=MTD",
            "categories": ["electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "A.B. Distributing, Inc.",
            "phone": "800-874-3300",
            "url": "http://abdistributing.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Cummins Allison",
            "phone": "800-786-5528",
            "url": "https://store.cumminsallison.com/live/default.aspx?appname=Store&tabname=Categories&catid=SUPPLIES%7CCURRENCY_COUNTER_CLEANING_KITS_AND_COVERS_DUSTERS_VACUUMS_FILTERS",
            "categories": ["electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "March Industries",
            "phone": "847-683-9990",
            "url": "http://www.marchinc.com/",
            "categories": ["electronics", "industrial"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "SUZOHAPP",
            "phone": "888-289-4277",
            "url": "https://na.suzohapp.com/wp/search.p?Q=datavac",
            "categories": ["electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "McMaster Carr",
            "phone": "630-834-9600",
            "url": "https://www.mcmaster.com/vacuum-cleaners",
            "categories": ["electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Essendant",
            "phone": "847-627-7000",
            "url": "none",
            "categories": ["electronics"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Power Equipment Direct",
            "phone": "800-710-7499",
            "url": "https://www.powerequipmentdirect.com/search-results.php?cx=017424973013417816314%3Apckaiqvyyhw&cof=FORID%3A10&ie=UTF-8&x=0&y=0&q=metro",
            "categories": ["camping"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Palos Sports, Inc.",
            "phone": "800-233-5484",
            "url": "https://www.palossports.com/store/prodpage3.cfm/CategoryID/20581/SubCatID/867/file.htm",
            "categories": ["camping"],
            "country": "US",
            "state": "Illinois"
        },
        {
            "name": "Livin The Dog Life",
            "phone": "800-931-1562",
            "url": "http://www.livinthedoglife.com/index.html",
            "categories": ["pets"],
            "country": "US",
            "state": "Indiana"
        },
        {
            "name": "Fast Bargain Deals",
            "phone": "614-599-9110",
            "url": "http://www.fastbargaindeals.com/",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "Indiana"
        },
        {
            "name": "MSW",
            "phone": "317-472-5800",
            "url": "https://www.whse.com/",
            "categories": ["motorcycle"],
            "country": "US",
            "state": "Indiana"
        },
        {
            "name": "DetailPro Inc",
            "phone": "855-337-2577",
            "url": "https://www.detailpro.com/?s=metro&lang=en",
            "categories": ["auto"],
            "country": "US",
            "state": "Indiana"
        },
        {
            "name": "Cozy Winters",
            "phone": "800-340-1528",
            "url": "https://cozywinters.com/shop/pet-dryer.html",
            "categories": ["pets"],
            "country": "US",
            "state": "Indiana"
        },
        {
            "name": "Valley Vet Supplies",
            "phone": "800-419-9524",
            "url": "https://www.valleyvet.com/ct_search_results.html?gas=Metropolitan%20Vacuum%20Cleaner",
            "categories": ["pets"],
            "country": "US",
            "state": "Kansas"
        },
        {
            "name": "Sparkle Auto Detailing",
            "phone": "866-372-9559",
            "url": "http://www.sparkleauto.com/Metropolitan-Vac-N-Blo-Compact-Vacuum-VNB-83BA-031275112273.html",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Kansas"
        },
        {
            "name": "KC Auto Gifts & Accessories",
            "phone": "913-422-5126",
            "url": "http://www.kcautoacc.com/Vacuum-Cleaners-Car-Dryers_c_5915.html",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "Kansas"
        },
        {
            "name": "Cobalt Boats, LLC",
            "phone": "620-325-2653",
            "url": "https://cobaltboats.com/#.WDoQF4V6xsM",
            "categories": ["camping"],
            "country": "US",
            "state": "Kansas"
        },
        {
            "name": "Camping World",
            "phone": "800-626-3636",
            "url": "https://www.campingworld.com/metrovac-electrasweep",
            "categories": ["home"],
            "country": "US",
            "state": "Kentucky"
        },
        {
            "name": "SmartPak Equine. LLC",
            "phone": "800-461-8898",
            "url": "https://www.smartpakequine.com/pt/vac-nblo-pro-1768",
            "categories": ["pets"],
            "country": "US",
            "state": "Massachusetts"
        },
        {
            "name": "PetEdge, Inc.",
            "phone": "800-738-3343",
            "url": "https://www.petedge.com/zpetedgemain/catalog/simpleSearch.jsf?sort=RA&wec-appid=PEDM_WEBSHOP_TR&show=72&view=grid&simpleSearchString=metro&wec-locale=en_US",
            "categories": ["pets"],
            "country": "US",
            "state": "Massachusetts"
        },
        {
            "name": "Tractor Supply Company",
            "phone": "877-718-6750",
            "url": "https://www.tractorsupply.com/tsc/search/metrovac",
            "categories": ["pets", ],
            "country": "US",
            "state": "Tennessee",
        },
        {
            "name": "JENSEN Tools + Supply",
            "phone": "888-887-9473",
            "url": "https://www.jensentools.com/search.aspx?f=2%3AMETROVAC",
            "categories": ["auto", "motorcycle", "electronics"],
            "country": "US",
            "state": "Massachusetts"
        },
        {
            "name": "You-do-it Electronics Center",
            "phone": "781-449-1005",
            "url": "http://www.youdoitelectronics.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Massachusetts"
        },
        {
            "name": "Eastern Performance",
            "phone": "410-451-5181",
            "url": "http://www.easternperformance.com/catalogsearch/result/?q=METRO",
            "categories": ["pets", "auto", "motorcycle", "industrial"],
            "country": "US",
            "state": "Maryland"
        },
        {
            "name": "EMS Innovations Inc",
            "phone": "410-255-3314",
            "url": "none",
            "categories": ["camping", "industrial"],
            "country": "US",
            "state": "Maryland"
        },
        {
            "name": "Losberger US",
            "phone": "301-682-8000",
            "url": "https://www.losberger.com/us/en_US/event-tents/",
            "categories": ["camping"],
            "country": "US",
            "state": "Maryland"
        },
        {
            "name": "K-9 Specialties",
            "phone": "586-939-5960",
            "url": "none",
            "categories": ["pets"],
            "country": "US",
            "state": "Michigan"
        },
        {
            "name": "Chow Hound Pet Supplies",
            "phone": "616-452-7877",
            "url": "http://chowhoundpet.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "Michigan"
        },
        {
            "name": "Corvette Central",
            "phone": "800-345-4122",
            "url": "https://www.corvettecentral.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Michigan"
        },
        {
            "name": "BankSupplies",
            "phone": "800-968-7868",
            "url": "https://banksupplies.com/731-50500",
            "categories": ["electronics"],
            "country": "US",
            "state": "Michigan"
        },
        {
            "name": "Great Lakes Sports",
            "phone": "800-446-2114",
            "url": "https://www.greatlakessports.com/",
            "categories": ["camping"],
            "country": "US",
            "state": "Michigan"
        },
        {
            "name": "Tumbl Trak",
            "phone": "800-331-4362",
            "url": "https://www.tumbltrak.com/",
            "categories": ["camping"],
            "country": "US",
            "state": "Michigan"
        },
        {
            "name": "Gym Closet",
            "phone": "800-445-8873",
            "url": "http://www.gymcloset.com/catalogsearch/result/index/?dir=asc&order=price&q=metro",
            "categories": ["camping"],
            "country": "US",
            "state": "Michigan"
        },
        {
            "name": "Target",
            "phone": "800-440-0680",
            "url": "https://www.target.com/s?searchTerm=Metro%2Bvac&category=0%7CAll%7Cmatchallpartial%7Call%2Bcategories&lnk=snav_sbox_Metro%2Bvac",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "Minnesota"
        },
        {
            "name": "Save on Sporting Goods",
            "phone": "651-214-0667",
            "url": "https://www.amazon.com/s?me=A25QZIU04NMM0A&marketplaceID=ATVPDKIKX0DER",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "Minnesota"
        },
        {
            "name": "Cable Connection & Supply Co",
            "phone": "507-334-8926",
            "url": "https://www.cableconnectionsupply.com/",
            "categories": ["home"],
            "country": "US",
            "state": "Minnesota"
        },
        {
            "name": "Atrix International Inc",
            "phone": "952-894-6154",
            "url": "https://atrix.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Minnesota"
        },
        {
            "name": "Gopher Sports",
            "phone": "855-899-9560",
            "url": "https://www.gophersport.com/search/?query=INFLATOR/DEFLATOR",
            "categories": ["camping"],
            "country": "US",
            "state": "Minnesota"
        },
        {
            "name": "UPCO",
            "phone": "800-254-8726",
            "url": "http://www.upco.com/is-bin/INTERSHOP.enfinity/WFS/Upco-Upco-Site/en_US/-/USD/ViewParametricSearch-AdvancedSearch?WFSimpleSearch_NameOrID=metro&PageSize=10000",
            "categories": ["pets"],
            "country": "US",
            "state": "Missouri"
        },
        {
            "name": "Countryside Pet Supply",
            "phone": "417-256-1981",
            "url": "https://www.countrysidepet.com/search?q=metro&Search=",
            "categories": ["pets"],
            "country": "US",
            "state": "Missouri"
        },
        {
            "name": "Fast Lane Mobile Wash & Detail, LLC",
            "phone": "866-798-9011",
            "url": "https://www.lanescarproducts.com/brands/Metropolitan.html?sort=featured",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Missouri"
        },
        {
            "name": "Crown Enterprises",
            "phone": "406-755-6484",
            "url": "https://www.sportsmanskihaus.com/",
            "categories": ["camping"],
            "country": "US",
            "state": "Montana"
        },
        {
            "name": "Hydro Groom, Inc.",
            "phone": "336-520-1890",
            "url": "https://www.hydrogroom.com/default.asp",
            "categories": ["pets"],
            "country": "US",
            "state": "North Carolina"
        },
        {
            "name": "Prokennel.com",
            "phone": "800-446-6608",
            "url": "http://www.prokennel.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "North Carolina"
        },
        {
            "name": "Mc Kenzie Sports Products LLC",
            "phone": "704-279-7985",
            "url": "https://www.mckenziesp.com/Default.aspx",
            "categories": ["pets"],
            "country": "US",
            "state": "North Carolina"
        },
        {
            "name": "Sirchie",
            "phone": "800-356-7311",
            "url": "https://www.sirchie.com/",
            "categories": ["auto", "home"],
            "country": "US",
            "state": "North Carolina"
        },
        {
            "name": "York Sanitary Supply",
            "phone": "336-674-6428",
            "url": "none",
            "categories": ["auto"],
            "country": "US",
            "state": "North Carolina"
        },
        {
            "name": "All-Spec, a Hisco subsidiary",
            "phone": "800-537-0351",
            "url": "https://www.all-spec.com",
            "categories": ["electronics"],
            "country": "US",
            "state": "North Carolina"
        },
        {
            "name": "ARCA",
            "phone": "919-442-5200",
            "url": "https://arca.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "North Carolina"
        },
        {
            "name": "Lambert Vet Supply",
            "phone": "800-347-6337",
            "url": "https://www.lambertvetsupply.com/search.asp?keyword=Metro&search=",
            "categories": ["pets"],
            "country": "US",
            "state": "Nebraska"
        },
        {
            "name": "KV Supply",
            "phone": "844-493-6817",
            "url": "https://www.kvsupply.com/Search.aspx?query=metro",
            "categories": ["pets"],
            "country": "US",
            "state": "Nebraska"
        },
        {
            "name": "Dultmeier Sales",
            "phone": "888-677-5054",
            "url": "https://www.dultmeier.com/search.asp?searchstring=master%20blaster",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Nebraska"
        },
        {
            "name": "Brookstone",
            "phone": "866-576-7337",
            "url": "https://www.brookstone.com/home?q=Metro%C2%AE#q=Metro%C2%AE&srule=alphabetical%20A-Z&sz=24&start=0",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "New Hampshire"
        },
        {
            "name": "Bob's Sharp All",
            "phone": "603-279-8792",
            "url": "https://www.bobssharpall.net/",
            "categories": ["pets"],
            "country": "US",
            "state": "New Hampshire"
        },
        {
            "name": "State of Nine Ltd",
            "phone": "877-­449-­7222",
            "url": "http://www.stateofnine.com/index.php/catalogsearch/result/?q=vacuum",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "New Hampshire"
        },
        {
            "name": "Bavarian Autosport",
            "phone": "800-535-2002",
            "url": "https://www.bavauto.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "New Hampshire"
        },
        {
            "name": "Herrington Catalog",
            "phone": "877-435-7156",
            "url": "none",
            "categories": ["auto", "home"],
            "country": "US",
            "state": "New Hampshire"
        },
        {
            "name": "Lynn's Grooming",
            "phone": "732-431-5071",
            "url": "none",
            "categories": ["pets"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "Cherrybrook",
            "phone": "800-524-0820",
            "url": "https://www.cherrybrook.com/brands/Metro.html",
            "categories": ["pets"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "UnbeatableSale.com, Inc.",
            "phone": "888-657-8436",
            "url": "https://www.unbeatablesale.com/lsearch.jhtm?keywords=metro",
            "categories": ["auto", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "CARiD.com",
            "phone": "800-505-3274",
            "url": "https://www.toolsid.com/metrovac/",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "Casa.com",
            "phone": "855-687-2272",
            "url": "none",
            "categories": ["auto", "home", "electronics"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "Detailer's Domain",
            "phone": "201-768-1818",
            "url": "https://www.detailersdomain.com/search?type=product&q=metro",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "Luxury Home",
            "phone": "732-353-6559",
            "url": "https://theluxuryhomestore.com/search?q=metrovac",
            "categories": ["auto", "home", "electronics"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "Bed Bath & Beyond",
            "phone": "800-462-3966",
            "url": "http://www.bedbathandbeyond.com/store/brand/metro-vacuum/1401?ta=typeahead",
            "categories": ["auto", "home", "electronics"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "Shield & Sheen",
            "phone": "609-216-0478",
            "url": "https://squareup.com/market/shieldandsheen",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "CWR Distribution ",
            "phone": "800-527-3306",
            "url": "https://cwrdistribution.com/manufacturer/100583/metrovac",
            "categories": ["camping"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "FlagHouse, Inc.",
            "phone": "800-793-7900",
            "url": "https://www.flaghouse.com",
            "categories": ["camping"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "InflatableBoatparts.com",
            "phone": "973-506-7385",
            "url": "http://shop.inflatableboatparts.com/catalogsearch/result/?q=METRO",
            "categories": ["camping"],
            "country": "US",
            "state": "New Jersey"
        },
        {
            "name": "America's Business to Consumers",
            "phone": "775-888-1378",
            "url": "https://www.usab2c.com/manufacturer/Metropolitan_american_made_vacuums",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "Nevada"
        },
        {
            "name": "Groomer's Choice",
            "phone": "888-364-6242",
            "url": "https://www.groomerschoice.com/Dryers/products/602/",
            "categories": ["pets"],
            "country": "US",
            "state": "Nevada"
        },
        {
            "name": "Kiesub Electronics",
            "phone": "702-733-0024",
            "url": "https://kiesub.com/product/metro-vac-ed-500-datavac-electric-duster/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Nevada"
        },
        {
            "name": "Superior Sewing Machine & Supply LLC",
            "phone": "212-691-5900",
            "url": "http://www.supsew.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Dogroom Products Inc",
            "phone": "516-483-8930",
            "url": "none",
            "categories": ["pets"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Marvin Garden Store",
            "phone": "888-758-6191",
            "url": "https://marvingardensstore.com/search.php?search_query=METROVAC&Search=GO",
            "categories": ["pets"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Glyants Enterprises Inc",
            "phone": "855-870-7070",
            "url": "http://www.glyants.com",
            "categories": ["pets"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Auto Barn",
            "phone": "888-484-9560",
            "url": "https://www.autobarn.net/metrovac-products.html",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "ElectOtronics",
            "phone": "none",
            "url": "http://www.electotronics.com/search.aspx?find=MetroVac",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Self Serve Dog Wash",
            "phone": "585-388-6996",
            "url": "http://www.selfservedogwash.com/dryers.htm",
            "categories": ["pets"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Global Industrial Equipment",
            "phone": "888-978-7759",
            "url": "https://www.globalindustrial.com/m/searchResult?ps=39&q=metrovac&x=0&y=0",
            "categories": ["auto", "home", "motorcycle", "electronics", "industrial"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "MSC Industrial Supply",
            "phone": "800-645-7270",
            "url": "https://www.mscdirect.com/browse/lookahead/tn/?searchAheadTerm=metro%2Ba&searchAhead=true&searchterm=Metro%2BAir%2BForce&typahddsp=Metro%2BAir%2BForce&hdrsrh=true",
            "categories": ["auto", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Brody Dog Auto",
            "phone": "716-785-3714",
            "url": "https://www.brodydogauto.com/default.asp",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "B & H Photo Video",
            "phone": "800-221-5743",
            "url": "https://www.bhphotovideo.com/c/search?Ntt=metro%2Bdatavac&N=0&InitialSearch...=",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Pure Adapt, Inc",
            "phone": "518-861-8811",
            "url": "https://www.pureadapt.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "123Stores, Inc",
            "phone": "646-593-8983",
            "url": "http://123stores.com/",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "CowRC",
            "phone": "631-716-5269",
            "url": "http://www.cowrc.com/#!/Jet-Blasters/c/11281157/offset=0&sort=normal",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "TALAS",
            "phone": "212-219-0770",
            "url": "https://www.talasonline.com/search?keywords=metro",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Caprice Electronics Inc",
            "phone": "718-222-0436",
            "url": "https://ceisales.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Hobby Heroes",
            "phone": "718-863-2400",
            "url": "https://www.hobbyheroes.com",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Adorama",
            "phone": "855-420-4806",
            "url": "https://www.adorama.com/l/?searchinfo=datavac",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Markertek Video Supply",
            "phone": "800-522-2025",
            "url": "http://audio-video-supply.markertek.com/search?sitepref=1&p=Q&lbc=markertek&uid=997501208&ts=custom&w=metro&af=br%3Ametropolitanvacuumcleanerco&isort=score&method=and&view=grid",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Dozier Equipment",
            "phone": "888-628-3466",
            "url": "https://www.globalindustrial.com/searchResult?_=1476726219633&ajaxDate=1476726203477&p=pcs_temp_do_not_sell%3DNo~pcs_vendor_store_only%3DNo~website_enable_code%3D1~~attr_brand%3DMetroVac&q=METRO",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Gaylord Bros Inc",
            "phone": "800-448-6160",
            "url": "https://www.gaylord.com",
            "categories": ["electronics"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Blue Chip Medical Products",
            "phone": "845-369-7535",
            "url": "http://www.bluechipmedical.com/index.php?s=inflator",
            "categories": ["camping"],
            "country": "US",
            "state": "New York"
        },
        {
            "name": "Schneider's Saddlery",
            "phone": "800-365-1311",
            "url": "https://www.sstack.com/index.cfm/fuseaction/product.browse/categoryAlias_name/Horse-Care_Grooming-Supplies_Vacuums/categoryID/9d486ff5-2ac3-46c0-be67-9374781444a8/?filter=&productView=grid&page=1&resultsPerPage=12&sortType=priceAsc",
            "categories": ["pets"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "PBS Animal Health",
            "phone": "800-321-0235",
            "url": "https://www.pbsanimalhealth.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "North Coast Pets",
            "phone": "888-858-7387",
            "url": "https://www.northcoastpets.com/category-s/218.htm",
            "categories": ["pets"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Robert J Matthews Co",
            "phone": "330-834-3000",
            "url": "https://www.rjmatthews.com/vendors/Metropolitan-Vacuum-Cleaner-Co/284.html",
            "categories": ["pets"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Big Dee's Tack & Vet Supplies",
            "phone": "800-321-2142",
            "url": "https://www.bigdweb.com/search.do?query=metro",
            "categories": ["pets"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Garrett Wade Co., Inc.",
            "phone": "800-221-2942",
            "url": "https://www.garrettwade.com/500w-hand-held-vacuum-blower-gp.html",
            "categories": ["auto", "home"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "44Tools",
            "phone": "513-603-1000",
            "url": "https://44tools.com/search.php?search_query=dryer&section=product",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Fastenal",
            "phone": "440-255-2240",
            "url": "https://www.fastenal.com/home",
            "categories": ["auto", "motorcycle", "electronics", "industrial"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Sportsman's Market, Inc.",
            "phone": "800-776-7897",
            "url": "https://www.sportys.com/toolshop/catalogsearch/result/?q=vac+n+",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Summit Racing Equipment",
            "phone": "800-230-3030",
            "url": "https://www.summitracing.com/search/brand/metrovac?GroupBy=ProductName",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Iron Pony Motorsports",
            "phone": "877-799-7669",
            "url": "https://www.ironpony.com/ipd/brand/bc2.asp?bname=Air-Force-Blaster",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Ohio Auto Supply Co., Inc.",
            "phone": "330-454-5105",
            "url": "https://www.professionaldetailingproducts.com/metrovac",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Garage Pitstop, a Block-A-Chip, LLC company",
            "phone": "440-251-2731",
            "url": "http://www.garagepitstop.com/store/care-maintenance.html?manufacturer=73",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Provantage LLC",
            "phone": "800-336-1166",
            "url": "http://www.provantage.com/service/searchsvcs/Q-P?QUERY=metro&MAN=MTRV",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Nothing But Software",
            "phone": "800-755-4619",
            "url": "https://www.nothingbutsavings.com/Search/METRO/1/10/AllCategories/Metropolitan-Vacuum-Company",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Schaffer Partners",
            "phone": "216-881-3474",
            "url": "http://www.pfi-awards.com/",
            "categories": ["auto", "home"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Jax Wax Inc.",
            "phone": "614-476-6769",
            "url": "https://store.jaxwax.com/searchresults.asp?Search=metro&Submit=",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Micro Center",
            "phone": "614-850-3675",
            "url": "https://www.microcenter.com/brand/4294870711/Metropolitan-Vacuum-Cleaner-Co",
            "categories": ["electronics"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Rontech",
            "phone": "800-466-1849",
            "url": "https://www.rontechusa.com/metrovac/",
            "categories": ["electronics", "pets"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Zebec of North America",
            "phone": "513-892-7400",
            "url": "http://www.zebec.com/",
            "categories": ["camping"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Southpaw Enterprises",
            "phone": "800-228-1698",
            "url": "https://www.southpaw.com/catalogsearch/result/?q=inflator",
            "categories": ["camping"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "Toledo Physical Education Supply",
            "phone": "800-225-7749",
            "url": "http://www.tpesonline.com/catalogsearch/result/index/?dir=asc&order=price&q=metro",
            "categories": ["camping"],
            "country": "US",
            "state": "Ohio"
        },
        {
            "name": "MJM Company - West",
            "phone": "818-661-8483",
            "url": "https://mjmcompany.com/pet-dryer.htm",
            "categories": ["pets"],
            "country": "US",
            "state": "Oregon"
        },
        {
            "name": "J&J Amusements, Inc",
            "phone": "503-304-8899",
            "url": "http://www.jjamusements.com/bumper-boats/accessories/inflator/",
            "categories": ["camping"],
            "country": "US",
            "state": "Oregon"
        },
        {
            "name": "Automatic Equipment Inc.",
            "phone": "787-782-5555",
            "url": "https://www.dog.com/Search.aspx?query=Metro",
            "categories": ["electronics"],
            "country": "US",
            "state": "Puerto Rico"
        },
        {
            "name": "Dog.com",
            "phone": "800-367-3647",
            "url": "https://www.dog.com/Search.aspx?query=Metro",
            "categories": ["pets"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "TABcom LLC",
            "phone": "570-384-5555",
            "url": "https://www.petsupplies.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "That Pet Place",
            "phone": "888-842-8738",
            "url": "https://www.thatpetplace.com/search#!dog-supplies/dog-grooming-supplies/dog-dryers&ea_a=Brand%3AMetropolitan-Vacuum-Cleaner-Co",
            "categories": ["pets"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "1800PetSupplies.com",
            "phone": "800-738-7877",
            "url": "https://www.petsupplies.com/Search.aspx?query=Metro%20Vac",
            "categories": ["pets"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "Detail King",
            "phone": "724-325-0008",
            "url": "https://www.detailking.com/search/?q=metro",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "CleanItSupply",
            "phone": "855-686-9688",
            "url": "https://www.cleanitsupply.com/nsearch.aspx?keywords=metrovac",
            "categories": ["home", "electronics", "industrial"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "Neutron USA",
            "phone": "800-813-4218",
            "url": "http://www.neutronusa.com/Manufacturer/index.cfm/ID/5077/Page/1",
            "categories": ["auto", "home", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "Grabiak Performance Center",
            "phone": "866-713-0162",
            "url": "https://www.gpcperformance.com/products?search_api_views_fulltext=metro&...=",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "D & H Distributing",
            "phone": "800-877-1200",
            "url": "https://www.dandh.com/v4/view?pageReq=dhMainNS&int_cid=NV9&utm_campaign=DHLogo",
            "categories": ["auto", "home", "motorcycle", "electronics", "camping"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "WebstaurantStore",
            "phone": "717-392-7472",
            "url": "https://www.webstaurantstore.com/vendor/metrovac.html",
            "categories": ["industrial", "electronics", "camping"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "WPS, Inc.",
            "phone": "800-999-3388",
            "url": "https://www.wps-inc.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "Quill Corporation",
            "phone": "800-982-3400",
            "url": "https://www.quill.com/search?keywords=datavac&scf=&x=11&y=17etrovac&...=",
            "categories": ["home", "electronics"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "Fun and Function",
            "phone": "800-231-6329",
            "url": "https://funandfunction.com/magic-air-electric-inflator-deflator.html",
            "categories": ["camping"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "The Catty Shack",
            "phone": "864-363-4774",
            "url": "none",
            "categories": ["pets"],
            "country": "US",
            "state": "South Carolina"
        },
        {
            "name": "Clean Cycle",
            "phone": "888-438-2108",
            "url": "http://www.cleancycle.com/mm5/merchant.mvc?Store_Code=cleancycle&Screen=CTGY&Category_Code=equipment",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "South Carolina"
        },
        {
            "name": "Love Groomers",
            "phone": "844-610-1005",
            "url": "https://lovegroomers.com/collections/metro-dryers",
            "categories": ["pets"],
            "country": "US",
            "state": "South Dakota"
        },
        {
            "name": "Senproco Inc",
            "phone": "800-748-1777",
            "url": "http://www.senproco.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "South Dakota"
        },
        {
            "name": "Groomer's Best",
            "phone": "605-582-3013",
            "url": "https://www.groomersbest.com/main/shop/uncategorized/metrovac-air-force-commander/",
            "categories": ["pets"],
            "country": "US",
            "state": "South Dakota"
        },
        {
            "name": "Value Pet Supplies",
            "phone": "800-82583-738",
            "url": "https://best.valuepetsupplies.com/products/metro?cnt=90",
            "categories": ["pets"],
            "country": "US",
            "state": "Tennessee"
        },
        {
            "name": "Amusement Products",
            "phone": "423-892-7264",
            "url": "https://amusementproducts.com/",
            "categories": ["camping"],
            "country": "US",
            "state": "Tennessee"
        },
        {
            "name": "Cougar Chemical",
            "phone": "800-467-3270",
            "url": "https://cougarchemical.com/search?q=metro",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Tennessee"
        },
        {
            "name": "Future Pets",
            "phone": "888-738-3976",
            "url": "https://www.futurepets.com/cgi-bin/search.exe?BP=1&RCAT=100.",
            "categories": ["pets"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Klearwater Pet Manufacturing & Distributing",
            "phone": "817-492-0100",
            "url": "none",
            "categories": ["pets"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "ProGroom",
            "phone": "936-894-3292",
            "url": "http://progroom.com/catalog/advanced_search_result.php?osCsid=e4a8309103dcc6c70050cf0c2e4e4cec&keywords=metro&categories_id=&inc_subcat=1&manufacturers_id=32&pfrom=&pto=&dfrom=&dto=&x=0&y=0",
            "categories": ["pets", "home", "electronics"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "KPets",
            "phone": "888-785-3588",
            "url": "http://stores.kpets.com/brands/Metro.html",
            "categories": ["pets"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Tucker Rocky Distributing",
            "phone": "817-258-9000",
            "url": "https://www.tucker.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "The Garage Store LLC",
            "phone": "888-411-1552",
            "url": "https://www.mygaragestore.com/SearchResult.aspx",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Equalizer Industries, Inc.",
            "phone": "800-334-1334",
            "url": "https://www.equalizer.com/",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "CarGuyGear.com",
            "phone": "713-926-2276",
            "url": "http://www.carguygear.com/mobile/Category.aspx?id=23",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Lufkin Rubber & Gasket Co",
            "phone": "936-639-1101",
            "url": "http://lufkinrubber.com/",
            "categories": ["auto", "motorcycle", "industrial"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Seyco",
            "phone": "800-462-3353",
            "url": "http://seyco.com/",
            "categories": ["auto", "home", "motorcycle"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Specialized Products Company",
            "phone": "800-866-5353",
            "url": "https://www.specialized.net/brand/metro-vac",
            "categories": ["electronics"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Altex Computers & Electronics",
            "phone": "800-531-5369",
            "url": "https://www.altex.com",
            "categories": ["electronics"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "ACP Direct",
            "phone": "800-232-2979",
            "url": "https://www.acpdirect.com",
            "categories": ["electronics"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "BSN Sports",
            "phone": "877-645-3050",
            "url": "https://www.bsnsports.com/search/?Ntt=MAGIC%2BAIR",
            "categories": ["camping"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name" : "Grit Sports & Outdoors",
            "phone" : "800-432-6319",
            "url": "none",
            "categories" : ["auto","pets","motorcycle","camping"],
            "country" : "US",
            "state" : "Texas"
        },
        {
            "name": "RallySport Direct",
            "phone": "888-457-2559",
            "url": "https://www.rallysportdirect.com/brand/metrovac",
            "categories": ["auto"],
            "country": "US",
            "state": "Utah"
        },
        {
            "name": "Hollinger Corporation",
            "phone": "540-898-7300",
            "url": "http://www.hollingermetaledge.com/",
            "categories": ["pets"],
            "country": "US",
            "state": "Virginia"
        },
        {
            "name": "Vermont Country Store",
            "phone": "888-298-8162",
            "url": "https://www.vermontcountrystore.com/?_=1480193448941&callback=jQuery31107739079346840758_1480193448940&do=json&i=1&q=vacuum&sort=maxPrice",
            "categories": ["home"],
            "country": "US",
            "state": "Vermont"
        },
        {
            "name": "Care-A-Lot Pet Supply",
            "phone": "800-343-7680",
            "url": "https://www.carealotpets.com/Departments/Dog-Supplies/Grooming/Dryers.aspx",
            "categories": ["pets"],
            "country": "US",
            "state": "Virginia"
        },
        {
            "name": "Griot's Garage, Inc.",
            "phone": "800-345-5789",
            "url": "https://www.griotsgarage.com/search.do?query=air%2Bblower",
            "categories": ["auto"],
            "country": "US",
            "state": "Washington"
        },
        {
            "name": "Technology Unlimited",
            "phone": "206-575-8644",
            "url": "http://tuiusa.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Washington"
        },
        {
            "name": "Leerburg Ent. Inc.",
            "phone": "715-235-6502",
            "url": "http://leerburg.com/search/search/results/searchid/38045",
            "categories": ["pets"],
            "country": "US",
            "state": "Wisconsin"
        },
        {
            "name": "A1 Pet Supply",
            "phone": "866-532-3647",
            "url": "https://a1petsupply.com/secure_html/aa-metro.htm",
            "categories": ["pets"],
            "country": "US",
            "state": "Wisconsin"
        },
        {
            "name": "Nasco International Inc",
            "phone": "920-563-2446",
            "url": "https://www.enasco.com/",
            "categories": ["pets", "camping"],
            "country": "US",
            "state": "Wisconsin"
        },
        {
            "name": "Data Financial, Inc.",
            "phone": "262-243-5511",
            "url": "http://www.datafinancial.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Wisconsin"
        },
        {
            "name": "Marsh Electronics, Inc.",
            "phone": "800-926-2774",
            "url": "https://www.marshelectronics.com/",
            "categories": ["electronics"],
            "country": "US",
            "state": "Wisconsin"
        },
        {
            "name": "Balloons Etc Inc",
            "phone": "703-971-9733",
            "url": "https://www.balloonsdirect.com/supplies/inflators-and-regulators",
            "categories": ["camping"],
            "country": "US",
            "state": "Virginia"
        },
        {
            "name": "Blizzard's Custom Cycles & ATV",
            "phone": "304-744-3223",
            "url": "https://www.blizzardsvictorymotorcycles.com/",
            "categories": ["motorcycle"],
            "country": "US",
            "state": "West Virginia"
        },
        {
            "name": "Heiston Supply",
            "phone": "304-263-3364",
            "url": "http://www.heistonsupply.com/",
            "categories": ["industrial"],
            "country": "US",
            "state": "West Virginia"
        },
        {
            "name": "IDS Care Care",
            "phone": "833 280 6703",
            "url": "https://idscarcare.com/collections/metro-vac",
            "categories": ["auto"],
            "country": "US",
            "state": "Florida"
        },
        {
            "name": "Kleen-Rite Corp",
            "phone": "800 233 3873",
            "url": "https://www.kleen-ritecorp.com/search.aspx?searchterm=metro",
            "categories": ["auto"],
            "country": "US",
            "state": "Pennsylvania"
        },
        {
            "name": "Carzilla",
            "phone": "403-200-6000",
            "url": "https://www.carzilla.ca/metrovac/?rq=metro",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Alberta"
        },
        {
            "name": "Parts Canada",
            "phone": "N/A",
            "url": "https://www.partscanada.com/dealer-locator/",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Alberta"
        },
        {
            "name": "Auto Obsessed",
            "phone": "780-229-0732",
            "url": "https://www.autoobsessed.com/search?type=product&q=metro",
            "categories": ["auto", "home", "motorcycle", "camping"],
            "country": "CA",
            "state": "Alberta"
        },
        {
            "name": "Wayfair Rentals",
            "phone": "204-523-4617",
            "url": "http://www.wayfairrentals.ca",
            "categories": ["electronics"],
            "country": "CA",
            "state": "Manitoba"
        },
        {
            "name": "Luv-A-Rug Services Inc",
            "phone": "250-590-6210",
            "url": "none",
            "categories": ["pets"],
            "country": "CA",
            "state": "BritishColumbia"
        },
        {
            "name": "Excalibur Sharpening & Supply Ltd",
            "phone": "604-882-0022",
            "url": "https://excalibur.bc.ca/index.php?main_page=advanced_search_result&search_in_description=1&zenid=qer6l0lj12af8r6evbnpj7e730&keyword=metro",
            "categories": ["pets"],
            "country": "CA",
            "state": "BritishColumbia"
        },
        {
            "name": "Western Rawhide & Harness Manufacturing Co Ltd",
            "phone": "204-233-7361",
            "url": "https://www.westernrawhide.com/",
            "categories": ["pets"],
            "country": "CA",
            "state": "Manitoba"
        },
        {
            "name": "Amazon.com.ca, Inc",
            "phone": "none",
            "url": "https://www.amazon.ca/s/ref=nb_sb_noss/162-0375355-9468015?url=search-alias%3Daps&field-keywords=metrovac",
            "categories": ["pets", "auto", "home", "motorcycle", "electronics"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Ren's Pets Depot",
            "phone": "866-736-7738",
            "url": "https://www.renspets.com/search?q=metro",
            "categories": ["pets"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Deboer Grooming Supplies",
            "phone": "800-787-2036",
            "url": "http://www.deboergroomingsupplies.com/searchresult.asp",
            "categories": ["pets"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Johnston Research & Performance, Inc. (JRP)",
            "phone": "905-822-7223",
            "url": "http://store.jrponline.com/webstore/",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "eShine Car Care Inc.",
            "phone": "888-392-8766",
            "url": "https://www.eshine.ca/collections/metrovac",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Car Care Shoppe",
            "phone": "613-512-1064",
            "url": "http://www.carcareshoppe.com/",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "AK Quality Parts Inc.",
            "phone": "416-783-3217",
            "url": "http://www.akqualityparts.com/",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Canada Computers",
            "phone": "905-946-9688",
            "url": "https://www.canadacomputers.com/",
            "categories": ["auto", "motorcycle", "electronics"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Ingram Micro",
            "phone": "305-593-5900",
            "url": "https://mi.ingrammicro.com/_layouts/CommerceServer/IM/search2.aspx#PNavDS=N:0,Ntk:Products,Ntt:metropolitan,Ntx:matchall",
            "categories": ["auto", "home", "motorcycle", "electronics"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Hunter Brand",
            "phone": "800-363-4559",
            "url": "https://hunterbrand.com/sub-categories.asp?node=10&lang=en&categ=6.4.2&nP...=",
            "categories": ["pets"],
            "country": "CA",
            "state": "Quebec"
        },
        {
            "name": "Equipements Industriels Joliette Inc",
            "phone": "450-756-0564",
            "url": "http://eij.ca/en",
            "categories": ["pets", "auto", "motorcycle"],
            "country": "CA",
            "state": "Quebec"
        },
        {
            "name": "Laboratoire Hygienex",
            "phone": "418-522-2332",
            "url": "http://www.hygienex.com/fr/hygienex/",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Quebec"
        },
        {
            "name": "Onlinezoo",
            "phone": "43-1-990-28-48",
            "url": "https://www.onlinezoo.at/de/catalogsearch/result/?q=Metro+Hundetrockner",
            "categories": ["pets"],
            "country": "INT",
            "state": "Austria"
        },
        {
            "name": "ABK IMPORTS Pvt. Ltd.",
            "phone": "02041280570",
            "url": "https://www.abkgrooming.com/search?type=product&q=METRO*",
            "categories": ["pets"],
            "country": "INT",
            "state": "INDIA"
        },
        {
            "name": "Prestige Pet Products PTY Ltd.",
            "phone": "61-7-5432-0200",
            "url": "http://www.prestigepetproducts.com.au/home.php",
            "categories": ["pets"],
            "country": "INT",
            "state": "Queensland, Australia"
        },
        {
            "name": "Car Care Products",
            "phone": "1300-006-007",
            "url": "https://www.eshine.ca/search?q=metro",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "New South Wales, Australia"
        },
        {
            "name": "BACS IT Protection",
            "phone": "1300-732-227",
            "url": "http://www.bacs.com.au/search.aspx?articleid=12&moduleid=13&keywords=datavac&sitesection=&sitesectiondescr=",
            "categories": ["electronics"],
            "country": "INT",
            "state": "New South Wales, Australia"
        },
        {
            "name": "Stern First Pty Ltd",
            "phone": "61-2-9905-5800",
            "url": "http://sternfirst.com.au/magic-air-inflators",
            "categories": ["camping"],
            "country": "INT",
            "state": "New South Wales, Australia"
        },
        {
            "name": "WAX-IT",
            "phone": "(03) 9330 2177",
            "url": "https://www.waxit.com.au/collections/metrovac",
            "categories": ["AUTO"],
            "country": "INT",
            "state": "Victoria, Australia"
        },
        {
            "name": "Transgroom N.V.",
            "phone": "32-0-5625-20-10",
            "url": "https://transgroom.com/en/products?search=METRO",
            "categories": ["pets"],
            "country": "INT",
            "state": "Belgium"
        },
        {
            "name": "WAX-IT",
            "phone": "32-55-303-119",
            "url": "http://www.wax-it.be/webshop/winkel.html?manufacturer=4",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Belgium"
        },
        {
            "name": "Ferrelam Sas",
            "phone": "(57) (1) 6510200",
            "url": "none",
            "categories": ["auto", "motorcycle", "industrial"],
            "country": "INT",
            "state": "Colombia"
        },
        {
            "name": "Vaclaujo S.A.",
            "phone": "506-2226-7795",
            "url": "http://www.vaclaujo.com/",
            "categories": ["pets"],
            "country": "INT",
            "state": "Costa Rica"
        },
        {
            "name": "Jaramillo Pets y cia s.c.a",
            "phone": "57 4 44 46 202",
            "url": "none",
            "categories": ["pets"],
            "country": "INT",
            "state": "Colombia"
        },
        {
            "name": "Datacable A.S.",
            "phone": "420 602 770 927",
            "url": "http://www.datacable.cz/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Czech Republic"
        },
        {
            "name": "DetailingPro",
            "phone": "420 493 814 300",
            "url": "https://www.detailingpro.cz/search?phrase=metrovac",
            "categories": ["auto", "motorcycle", "electronics"],
            "country": "INT",
            "state": "Czech Republic"
        },
        {
            "name": "PC Case Gear",
            "phone": "61 3 9560 2122",
            "url": "https://www.pccasegear.com/",
            "categories": ["pets", "electronics"],
            "country": "INT",
            "state": "Australia"
        },
        {
            "name": "Klinir - Société Mesure 2000",
            "phone": "04 37 65 21 72",
            "url": "http://www.klinir.com/catalogsearch/result/?q=datavac&x=0&y=0",
            "categories": ["electronics"],
            "country": "INT",
            "state": "France"
        },
        {
            "name": "DIFAC",
            "phone": "33-38-28-33-730",
            "url": "http://difac.general.e-catalogues.info/files/assets/basic-html/page-229.html",
            "categories": ["pets"],
            "country": "INT",
            "state": "France"
        },
        {
            "name": "Vivog (Dog Cat)",
            "phone": "33-247-733-843",
            "url": "https://www.dogcat.com/professionnel/product_info.php?products_id=19635&language=en",
            "categories": ["pets"],
            "country": "INT",
            "state": "France"
        },
        {
            "name": "Morelli Group",
            "phone": "0333 222 9944",
            "url": "https://www.slimsdetailing.co.uk/metrovac.html",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "RGS Group",
            "phone": "44 845 833 1837",
            "url": "https://www.itdusters.com/product/metro-datavac/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "United Kingdom"
        },
        {
            "name": "Slim's Detailing",
            "phone": "0333 222 9944",
            "url": "https://www.slimsdetailing.co.uk/collections/metrovac",
            "categories": ["Auto"],
            "country": "INT",
            "state": "United Kingdom"
        },
        {
            "name": "Seima, S.A.",
            "phone": "502-2319-9494",
            "url": "http://www.seima.com.gt/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Guatemala"
        },
        {
            "name": "Mundo Animal",
            "phone": "502-2258-1565",
            "url": "none",
            "categories": ["pets"],
            "country": "INT",
            "state": "Guatemala"
        },
        {
            "name": "ASIMCO Technologies Limited",
            "phone": "81-47-424-5495",
            "url": "none",
            "categories": ["pets"],
            "country": "INT",
            "state": "Chiba, Japan"
        },
        {
            "name": "Newport Co.",
            "phone": "81 78 647 83 82",
            "url": "none",
            "categories": ["pets", "electronics"],
            "country": "INT",
            "state": "Hyogo, Japan"
        },
        {
            "name": "Baltic Distribution",
            "phone": "371 29109868",
            "url": "https://www.thomas-shop.lv/en/search?orderby=position&orderway=desc&search_query=Metrovac",
            "categories": ["pets", "auto", "home", "electronics"],
            "country": "INT",
            "state": "Latvia"
        },
        {
            "name": "Electronica Steren, S.A. de C.V.",
            "phone": "01 800 500 9000",
            "url": "https://www.steren.com.mx/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Mexico"
        },
        {
            "name": "Disprovef Ecuador S.A.",
            "phone": "04-51-15-322",
            "url": "https://disprovef.com/90-secadoras",
            "categories": ["pets"],
            "country": "INT",
            "state": "Ecuador"
        },
        {
            "name": "AKB Longs B.V.",
            "phone": "0031 (0)71 5765200",
            "url": "https://www.akblongs.nl/index.html",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Netherlands"
        },
        {
            "name": "Fabrika Techniki",
            "phone": "800-555-7996",
            "url": "http://gamma-sales.ru/kompressor-nosimyy-elektricheskiy-metrovac-vacuum-electric-duster-ed-500/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Russia"
        },
        {
            "name": "ICD Skellefteå AB",
            "phone": "800-555-7996",
            "url": "http://www.icd.se/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Sweden"
        },
        {
            "name": "WTF Technology PTE LTD",
            "phone": "65 9788 0000",
            "url": "none",
            "categories": ["pets", "electronics"],
            "country": "INT",
            "state": "Singapore"
        },
        {
            "name": "E-Disti d.o.o.",
            "phone": "386 313 788 49",
            "url": "http://www.e-disti.com/metrovac/",
            "categories": ["pets", "auto", "electronics", "industrial"],
            "country": "INT",
            "state": "Slovenia"
        },
        {
            "name": "Auto Mystique Car Care",
            "phone": "97 14 33 888 04",
            "url": "https://www.amcc.ae/",
            "categories": ["auto"],
            "country": "INT",
            "state": "Dubai"
        },
        {
            "name": "Erich Hartkopf GmbH & Co. KG",
            "phone": "49-212-221-460",
            "url": "https://www.ehaso.de/de/metro/",
            "categories": ["pets"],
            "country": "INT",
            "state": "Germany"
        },
        {
            "name": "Carparts GmbH",
            "phone": "49 221 285 858 58",
            "url": "https://www.carparts.koeln/MetroVac_2",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Germany"
        },
        {
            "name": "Ostrand",
            "phone": "45-46-15-38-39",
            "url": "https://www.ostrand.dk/shop/air-force-commander-8275p.html",
            "categories": ["pets"],
            "country": "INT",
            "state": "Denmark"
        },
        {
            "name": "Maniac-Auto",
            "phone": "01 39 75 93 54",
            "url": "https://www.maniac-auto.com/fr/recherche?controller=search&orderby=position&orderway=desc&search_query=METRO&submit_search=",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "France"
        },
        {
            "name": "Bikedryer.co.uk",
            "phone": "0044 (0) 20 8445 6811",
            "url": "http://www.metrodryer.co.uk/",
            "categories": ["auto", "home", "motorcycle"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "Winners Detailing",
            "phone": "+44 020 8445 6811",
            "url": "none",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "Clean Your Car",
            "phone": "44 (0)1484 841 444",
            "url": "http://www.cleanyourcar.co.uk/index.php?searchStr=metro&_a=viewCat",
            "categories": ["auto", "home", "motorcycle"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "Car Dryers UK",
            "phone": "0044 (0) 20 8445 6811",
            "url": "https://www.cardryers.co.uk/",
            "categories": ["auto", "home", "motorcycle"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "Four for Four",
            "phone": "79 62 220 09",
            "url": "http://www.4al4.co.il/Site/pages/inPage.asp?catID=4&scatID=38&sscatID=49",
            "categories": ["pets"],
            "country": "INT",
            "state": "Israel"
        },
        {
            "name": "Christies Direct",
            "phone": "08 707 336 699",
            "url": "https://www.christiesdirect.com/en/Metrovac/b-16.aspx",
            "categories": ["pets"],
            "country": "INT",
            "state": "UnitedKingdom"
        },
        {
            "name": "Carzspa Autofresh.in",
            "phone": "982 560 4000",
            "url": "http://www.autofresh.in/index.php?route=product/search&filter_name=metrovac",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Gujarat, India"
        },
        {
            "name": "United Car Care",
            "phone": "0800 463 478",
            "url": "https://www.unitedcarcare.co.nz/collections/metrovac",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "New Zealand"
        },
        {
            "name": "Buff & Shine Ukraine LTD",
            "phone": "38 (097) 961.8587",
            "url": "http://www.buffandshine.com.ua/novaya-produkciya.htm",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Ukraine"
        },
        {
            "name": "Avesauto",
            "phone": "380 98 393 8874",
            "url": "http://avesauto.ua/",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Ukraine"
        },
        {
            "name": "LaCuraDellAuto",
            "phone": "011 39 08 09 26 56 31",
            "url": "http://www.lacuradellauto.it/catalogsearch/result/?cat=0&q=METRO",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Bari, Italy"
        },
        {
            "name": "Detailing Shine",
            "phone": "33 6 12 82 51 30",
            "url": "https://www.detailingshine.fr/",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "France"
        },
        {
            "name": "Petcetera",
            "phone": "44-0-1948-668100",
            "url": "https://www.petcetera.co.uk/catalogsearch/result/",
            "categories": ["pets"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "Hub International",
            "phone": "44-0-1491-628355",
            "url": "https://www.hubintsecured.co.uk/acatalog/Blaster_Dryers_Metro_Professional.html",
            "categories": ["pets"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "Snake Motorcycles",
            "phone": "044 (0) 20 8445 6811",
            "url": "http://www.snakemotorcycles.com/acatalog/motorbikedryers.html",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "KillerBrands",
            "phone": "+44 020 8445 6811",
            "url": "https://www.killerbrands.co.uk/metro-dryers",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "England"
        },
        {
            "name": "Zodiac International B.V.",
            "phone": "31 297 288 621",
            "url": "https://catalog.zodiac.nl/en/catalog/24-oil-chemicals-and-tools/oil-chemicals-and-tools/bike-dryer/-air-force-blaster-bike-dryers/",
            "categories": ["motorcycle"],
            "country": "INT",
            "state": "Netherlands"
        },
        {
            "name": "BikeNord",
            "phone": "046 29 22 22",
            "url": "https://www.bikenord.se/search?q=metro",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Sweden"
        },
        {
            "name": "Askle Sante",
            "phone": "33 4 66 02 15 15",
            "url": "none",
            "categories": ["camping"],
            "country": "INT",
            "state": "France"
        },
        {
            "name": "Animagroom",
            "phone": "302-299-026-027",
            "url": "https://animagroom.gr/",
            "categories": ["pets"],
            "country": "INT",
            "state": "Greece"
        },
        {
            "name": "Superyacht Spares B.V.",
            "phone": "31 183 639 193",
            "url": "https://www.superyachtspares.com/",
            "categories": ["camping"],
            "country": "INT",
            "state": "Netherlands"
        },
        {
            "name": "Dog Health",
            "phone": "011 44 1760 726 340",
            "url": "https://www.doghealth.co.uk/search?q=metro",
            "categories": ["pets"],
            "country": "INT",
            "state": "Norfolk"
        },
        {
            "name": "ITALSYSTEM s.a.s.",
            "phone": "(39) 05 41 731 428",
            "url": "http://www.1allsystems.com/doc/phon-per-cani-soffiatori.html",
            "categories": ["pets"],
            "country": "INT",
            "state": "Italy"
        },
        {
            "name": "Paghanini Engros AS",
            "phone": "47 22 35 00 50",
            "url": "http://www.paghanini.no/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Norway"
        },
        {
            "name": "Hallmark S.A.",
            "phone": "511-365-5659",
            "url": "http://www.hallmark.com.pe/",
            "categories": ["pets"],
            "country": "INT",
            "state": "Peru"
        },
        {
            "name": "Satchmo's AB",
            "phone": "46 (0) 46 37 35 50",
            "url": "http://www.satchmos.se/search/metro",
            "categories": ["pets"],
            "country": "INT",
            "state": "Sweden"
        },
        {
            "name": "Summit Racing Equipment",
            "phone": "800-230-3030",
            "url": "https://www.summitracing.com/search/brand/metrovac?GroupBy=ProductName",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Nevada"
        },
        {
            "name": "Summit Racing Equipment",
            "phone": "800-230-3030",
            "url": "https://www.summitracing.com/search/brand/metrovac?GroupBy=ProductName",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Georgia"
        },
        {
            "name": "Summit Racing Equipment",
            "phone": "800-230-3030",
            "url": "https://www.summitracing.com/search/brand/metrovac?GroupBy=ProductName",
            "categories": ["auto", "motorcycle"],
            "country": "US",
            "state": "Texas"
        },
        {
            "name": "Baskiville Ltd.",
            "phone": "6433028703",
            "url": "https://www.baskiville.co.nz/products/search?search=metrovac",
            "categories": ["electronics"],
            "country": "INT",
            "state": "NewZealand"
        },
        {
            "name": "Autodtl",
            "phone": "225400411",
            "url": "https://www.autodtl.pt/metrovac",
            "categories": ["auto", "motorcycle"],
            "country": "INT",
            "state": "Portugal"
        },
        {
            "name": "Furever Clean Dog Wash",
            "phone": "250-217-9433",
            "url": "https://fureverclean.ca/product-category/pet-grooming-dryers/",
            "categories": ["pets"],
            "country": "CA",
            "state": "BritishColumbia"
        },
        {
            "name": "Livestock Equipment Canada - Central Alberta",
            "phone": "780-818-1410",
            "url": "https://www.livestockequipment.ca/",
            "categories": ["pets"],
            "country": "CA",
            "state": "Alberta"
        },
        {
            "name": "Livestock Equipment Canada - Ontario",
            "phone": "1-800-962-1606",
            "url": "https://www.livestockequipment.ca/",
            "categories": ["pets"],
            "country": "CA",
            "state": "Ontario"
        },
        {
            "name": "Sweet Ride.ca, a division of Corporation G",
            "phone": "819-780-0840",
            "url": "none",
            "categories": ["auto", "motorcycle"],
            "country": "CA",
            "state": "Quebec"
        },
        {
            "name": "Le Groupe Sports-Inter Plus",
            "phone": "1-800-463-5561",
            "url": "https://www.sports-inter.com/en/search?search=YZ300",
            "categories": ["pets"],
            "country": "CA",
            "state": "Quebec"
        },
        {
            "name": "Groomers Mall GmbH",
            "phone": "41 79 587 52 98",
            "url": "http://www.groomers-mall.ch/epages/SHOP-KMU00120.sf/en_GB/?ObjectPath=/Shops/SHOP-KMU00120",
            "categories": ["pets"],
            "country": "INT",
            "state": "Switzerland"
        },
        {
            "name": "Clipper World",
            "phone": "03 5996 2777",
            "url": "https://www.clipperworld.com.au/Metrovac/sf/pl.php?resetbrand=1",
            "categories": ["pets"],
            "country": "INT",
            "state": "Australia"
        },
        {
            "name": "Centro de Limpieza",
            "phone": "502 2388 0000",
            "url": "https://www.grupomisol.com",
            "categories": ["pets"],
            "country": "INT",
            "state": "Guatemala"
        },
        {
            "name": "Impavet",
            "phone": "51937573315",
            "url": "https://www.impavet.com",
            "categories": ["pets"],
            "country": "INT",
            "state": "Peru"
        },
        {
            "name": "Suplidora Internacional Royal LTDA",
            "phone": "506 2218-1420",
            "url": "https://www.groomingmall.com/secadoras/910-secadora-azul-para-mesa-2-velocidades.html",
            "categories": ["pets"],
            "country": "INT",
            "state": "CostaRica"
        },
        {
            "name": "Crocodile Teeth",
            "phone": "3315706689",
            "url": "",
            "categories": ["pets"],
            "country": "INT",
            "state": "Mexico"
        },
        {
            "name": "Ranger's LLC",
            "phone": "81 45 482 9891",
            "url": "http://dog-rangers.com/products/detail.php?product_id=345",
            "categories": ["pets"],
            "country": "INT",
            "state": "Japan"
        },
        {
            "name": "Pro-Edge",
            "phone": "27 16 982 5892",
            "url": "https://www.proedge.co.za/pet-accessories/pet-dryers",
            "categories": ["pets"],
            "country": "INT",
            "state": "SouthAfrica"
        },
        {
            "name": "Petmarket",
            "phone": "41 52 233 83 66",
            "url": "https://petmarket.ch/index.php?id_category=38&controller=category",
            "categories": ["pets"],
            "country": "INT",
            "state": "Switzerland"
        },
        {
            "name": "Autodude",
            "phone": "075 328 5820",
            "url": "https://www.autodude.fi/fi/c/search?query=metrovac",
            "categories": ["auto"],
            "country": "INT",
            "state": "Finland"
        },
        {
            "name": "Autodude",
            "phone": "08 409 08 900",
            "url": "https://www.autodude.se/produktsok/?q=metrovac",
            "categories": ["auto"],
            "country": "INT",
            "state": "Sweden"
        },
        {
            "name": "I et S Diffusion",
            "phone": "262 692 77 02 09",
            "url": "",
            "categories": ["auto"],
            "country": "INT",
            "state": "LaReunion"
        },
        {
            "name": "Garasjetid AS",
            "phone": "47 33 48 23 70",
            "url": "https://www.garasjetid.no/metrovac",
            "categories": ["auto"],
            "country": "INT",
            "state": "Norway"
        },
        {
            "name": "Yail Noa Agencies Ltd.",
            "phone": "972-3-5509148",
            "url": "https://www.motyknit.com/%D7%A9%D7%95%D7%90%D7%91-%D7%90%D7%91%D7%A7-%D7%90%D7%A0%D7%98%D7%99-%D7%A1%D7%98%D7%98%D7%99/",
            "categories": ["auto"],
            "country": "INT",
            "state": "Israel"
        },
        {
            "name": "e_Disti d.o.o.",
            "phone": "386 313 788 49",
            "url": "https://www.e-disti.com/metrovac/",
            "categories": ["electronics"],
            "country": "INT",
            "state": "Croatia"
        },
        {
            "name": "GroomerShop sp. z o.o.",
            "phone": "48 61 666 12 20",
            "url": "https://www.groomershop.pl/",
            "categories": ["pets"],
            "country": "INT",
            "state": "Poland"
        },
    ]






$(document).ready(function() {


    //Sorting the locations by alphabetical order
    locations.sort(function(a, b) {
        a = a.state.toLowerCase().split(",").pop().replace(/\s/g, '');
        b = b.state.toLowerCase().split(",").pop().replace(/\s/g, '');


        return a < b ? -1 : a > b ? 1 : 0;
    });


    var new_state = "";


    //loop through all locations
    for (var j = 0; j < locations.length; j++) {

        var number = locations[j].phone;
        var categories = locations[j].categories.join(" ");
        var word = locations[j].state;






        if (locations[j].country == 'INT') {
            //state with not spaces or characters to use for classes
            var stateCont = word.split(",").pop().replace(/\s/g, '');
            var stateName = word;

        } else {
            var stateCont = word.split(",").pop().replace(/\s/g, '');
            var stateName = word;
        }

        if (locations[j].phone == "none") {
            var numberAnchor = " ";
        } else {
            var numberAnchor = "<a href='tel:" + number.replace(/-/g, '') + "'>" + number + "</a><br>";
        }

        if (locations[j].url == "none") {
            var urlAnchor = locations[j].name;
        } else {
            var urlAnchor = "<a href='" + locations[j].url + "' target='_blank'>" + locations[j].name + "</a>";
        }

        if (stateCont != new_state) {
            $(".locations").append("<div id='" + stateCont + "' class='location " + stateCont + " " + locations[j].country + "'><div class='specific_location'><h2>" + stateName + "</h2><hr></div><div class='location_flex'></div></div>");

        }



        if ($('.location').hasClass(stateCont)) {
            $(".location." + stateCont + " .location_flex")
                .append("<div class='location_reseller all " + stateCont + " " + locations[j].country + " " + categories + "'>" + urlAnchor + "<br>" + numberAnchor + locations[j].state + "<br>" + "</div>");
        }


        var new_state = stateCont;
    }





    $(window).on('load', function() {
        updateLocations();
    });



    $("select.filter_line, select.filter_location").change(updateLocations);

    function updateLocations() {
        var lineFilter = $('select.filter_line').val();
        var locationFilter = $('select.filter_location').val().toUpperCase();
        var parentDiv = $('.location');
        var div = $('.location_reseller');



        div.each(function(i, el) {
            if (!$(el).hasClass(lineFilter) || !$(el).hasClass(locationFilter)) {
                $(el).hide();
                $(el).addClass('hidden');
            } else {
                $(el).show();
                $(el).removeClass('hidden');
            }
        })

        parentDiv.each(function(i, el) {
            if (!$(el).hasClass(locationFilter)) {
                $(el).hide();
            } else {
                $(el).show();
            }

            if ($(el).children('.location_flex').children('.location_reseller').length === $(el).children('.location_flex').children('.location_reseller.hidden').length) {
                $(el).hide();
                $(el).addClass('hidden');
            } else {
                $(el).show();
                $(el).removeClass('hidden');
            }

        })


        if ($('.locations').children('.location').length === $('.locations').children('.location.hidden').length) {
            $('.locations').css('margin-bottom', "216px");
        } else {
            $('.locations').css('margin-bottom', "100px");
        }


    }

});